import {Injectable} from '@angular/core';
import {Locale, ServiceCode} from '../define';
import {ApiService} from './api.service';
import {Config} from '../config';
import { LOCALE_ID, Inject } from '@angular/core';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';

@Injectable({
  providedIn: 'root'
})

export class LanguagesService {
  public define: LanguagesInterface;

  private readonly builtinEn: Partial<LibLanguages>;
  private readonly builtinJa: Partial<LibLanguages>;
  private readonly builtinVi: Partial<LibLanguages>;

  constructor(private api: ApiService, @Inject(LOCALE_ID) public localeId: string, public intlService: IntlService) {
    // Builtin init
    this.builtinVi = {
      back: 'Quay về',
      view: 'Xem',
      add: 'Thêm',
      edit: 'Soạn thảo',
      cancel: 'Hủy bỏ',
      save: 'Lưu',
      excel: 'Excel',
      copy: 'Sao chép',
      delete: 'Xóa',
      saveSetting: 'Lưu thiết lập',
      resetSetting: 'Reset thiết lập',

      include: 'Bao gồm',
      exclude: 'Không chứa',
      contains: 'Bao gồm',
      between: 'Ở giữa',
      outside: 'Ở ngoài',
      startWith: 'Bắt đầu với',
      endWith: 'Kết thúc với',
      no: 'Không',
      yes: 'Có',
      close: 'Đóng',
      sample: 'Dữ liệu mẫu',
      import: 'Import',
      column: 'Cột',
      apply: 'Áp dụng',
      selected: 'Đã chọn',
      unselected: 'Chưa được chọn',
      select: 'Chọn',
      deselect: 'Bỏ chọn',
      selectAll: 'Chọn hết',
      deselectAll: 'Bỏ chọn hết',
      width: 'Chiều rộng',
      locked: 'Khóa cột',
      fitColumn: 'Điều chỉnh cột',
      selectRowMessage: 'Hãy chọn ít nhất một hàng.',
      deleteConfirmMessage: 'Bạn có chắc chắn muốn xóa?',
      deletedMessage: 'Đã xóa',
      updatedMessage: 'Đã cập nhật',
      requiredMessage: 'Đây là mục bắt buộc nhập',
      selectFileImportMessage: 'Hãy chọn file import.',
      importSuccessMessage: 'Đã import thành công.',

      confirm: 'Xác nhận',
      error: 'Lỗi',
      previous: 'Về trước',
      next: 'Kế tiếp',

      groupPanelEmpty: 'Rỗng',
      noRecords: 'Không có dữ liệu',
      pagerFirstPage: 'Trang đầu tiên',
      pagerLastPage: 'Trang cuối cùng',
      pagerPreviousPage: 'Trang trước',
      pagerNextPage: 'Trang sau',
      pagerPage: 'trang',
      pagerItemsPerPage: 'dòng/trang',
      pagerOf: '/',
      pagerItems: 'dòng',
      pagerPageNumberInputTitle: 'Nhập trang',
      filter: 'Tìm kiếm',
      filterEqOperator: 'filterEqOperator',
      filterNotEqOperator: 'filterNotEqOperator',
      filterIsNullOperator: 'filterIsNullOperator',
      filterIsNotNullOperator: 'filterIsNotNullOperator',
      filterIsEmptyOperator: 'filterIsEmptyOperator',
      filterIsNotEmptyOperator: 'filterIsNotEmptyOperator',
      filterStartsWithOperator: 'filterStartsWithOperator',
      filterContainsOperator: 'filterContainsOperator',
      filterNotContainsOperator: 'filterNotContainsOperator',
      filterEndsWithOperator: 'filterEndsWithOperator',
      filterGteOperator: 'filterGteOperator',
      filterGtOperator: 'filterGtOperator',
      filterLteOperator: 'filterLteOperator',
      filterLtOperator: 'filterLtOperator',
      filterIsTrue: 'filterIsTrue',
      filterIsFalse: 'filterIsFalse',
      filterBooleanAll: 'filterBooleanAll',
      filterAfterOrEqualOperator: 'filterAfterOrEqualOperator',
      filterAfterOperator: 'filterAfterOperator',
      filterBeforeOperator: 'filterBeforeOperator',
      filterBeforeOrEqualOperator: 'filterBeforeOrEqualOperator',
      filterFilterButton: 'Tìm kiếm',
      filterClearButton: 'Xóa',
      filterAndLogic: 'filterAndLogic',
      filterOrLogic: 'filterOrLogic',
      loading: 'Loading',
      columnMenu: 'Menu cột',
      columnSetting: 'Thiết lập cột',
      columns: 'Cột',
      lock: 'Khóa',
      unlock: 'Mở khóa',
      sortable: 'Có thể sắp xếp',
      sortAscending: 'Sắp xếp tăng',
      sortDescending: 'Sắp xếp giảm',
      sortedAscending: 'Sắp xếp tăng',
      sortedDescending: 'Sắp xếp giảm',
      sortedDefault: 'Mặc định',
      columnsApply: 'Áp dụng',
      columnsReset: 'Reset',
      detailExpand: 'Mở rộng',
      detailCollapse: 'Thu gọn',
      filterDateToday: 'filterDateToday',
      filterDateToggle: 'filterDateToggle',
      filterNumericDecrement: 'filterNumericDecrement',
      filterNumericIncrement: 'filterNumericIncrement',

      searchPaneTitle: 'Tìm kiếm',
      searchNull: 'Tìm null',
      reset: 'Reset'
    };

    this.builtinEn = {
      back: 'Back',
      view: 'View',
      add: 'Add',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      excel: 'Excel',
      copy: 'Copy',
      delete: 'Delete',
      saveSetting: 'Save setting',
      resetSetting: 'Reset setting',
      include: 'Include',
      exclude: 'Exclude',
      contains: 'Contains',
      between: 'Between',
      outside: 'Outside',
      startWith: 'Start with',
      endWith: 'End with',
      no: 'No',
      yes: 'Yes',
      close: 'Close',
      sample: 'Sample',
      import: 'Import',
      column: 'Column',
      apply: 'Apply',
      selected: 'Selected',
      unselected: 'Unselected',
      select: 'Select',
      deselect: 'Deselect',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      width: 'Width',
      locked: 'Locked',
      fitColumn: 'Fit column',

      confirm: 'Confirm',
      error: 'Error',
      previous: 'Previous',
      next: 'Next',

      selectRowMessage: 'Please select a row.',
      deleteConfirmMessage: 'Are you sure to delete?',
      deletedMessage: 'Deleted',
      updatedMessage: 'Updated',
      requiredMessage: 'This is required item.',
      selectFileImportMessage: 'Please select import file.',
      importSuccessMessage: 'Imported success.',

      groupPanelEmpty: 'Empty',
      noRecords: 'No records',
      pagerFirstPage: 'First page',
      pagerLastPage: 'Last page',
      pagerPreviousPage: 'Previous page',
      pagerNextPage: 'Next page',
      pagerPage: 'page',
      pagerItemsPerPage: 'items per page',
      pagerOf: 'of',
      pagerItems: 'items',
      pagerPageNumberInputTitle: 'Page number input',
      filter: 'Filter',
      filterEqOperator: 'filterEqOperator',
      filterNotEqOperator: 'filterNotEqOperator',
      filterIsNullOperator: 'filterIsNullOperator',
      filterIsNotNullOperator: 'filterIsNotNullOperator',
      filterIsEmptyOperator: 'filterIsEmptyOperator',
      filterIsNotEmptyOperator: 'filterIsNotEmptyOperator',
      filterStartsWithOperator: 'filterStartsWithOperator',
      filterContainsOperator: 'filterContainsOperator',
      filterNotContainsOperator: 'filterNotContainsOperator',
      filterEndsWithOperator: 'filterEndsWithOperator',
      filterGteOperator: 'filterGteOperator',
      filterGtOperator: 'filterGtOperator',
      filterLteOperator: 'filterLteOperator',
      filterLtOperator: 'filterLtOperator',
      filterIsTrue: 'filterIsTrue',
      filterIsFalse: 'filterIsFalse',
      filterBooleanAll: 'filterBooleanAll',
      filterAfterOrEqualOperator: 'filterAfterOrEqualOperator',
      filterAfterOperator: 'filterAfterOperator',
      filterBeforeOperator: 'filterBeforeOperator',
      filterBeforeOrEqualOperator: 'filterBeforeOrEqualOperator',
      filterFilterButton: 'Filter',
      filterClearButton: 'Clear',
      filterAndLogic: 'filterAndLogic',
      filterOrLogic: 'filterOrLogic',
      loading: 'Loading',
      columnMenu: 'Column menu',
      columnSetting: 'Column setting',
      columns: 'Columns',
      lock: 'Lock',
      unlock: 'Unlock',
      sortable: 'Sortable',
      sortAscending: 'Ascending',
      sortDescending: 'Descending',
      sortedAscending: 'Ascending',
      sortedDescending: 'Descending',
      sortedDefault: 'Default',
      columnsApply: 'Apply',
      columnsReset: 'Reset',
      detailExpand: 'Expand',
      detailCollapse: 'Collapse',
      filterDateToday: 'filterDateToday',
      filterDateToggle: 'filterDateToggle',
      filterNumericDecrement: 'filterNumericDecrement',
      filterNumericIncrement: 'filterNumericIncrement',

      searchPaneTitle: 'Search',
      searchNull: 'Search null',
      reset: 'Reset'
    };

    this.builtinJa = {
      back: '戻る',
      view: '表示',
      add: '追加',
      edit: '編集',
      cancel: 'キャンセル',
      save: '保存',
      excel: 'Excel',
      copy: '複写',
      delete: '削除',
      saveSetting: '設定保存',
      resetSetting: '設定初期化',
      include: '含む',
      exclude: '含まない',
      contains: '含む',
      between: '内側',
      outside: '外側',
      startWith: 'で始める',
      endWith: 'で終わる',
      no: 'いいえ',
      yes: 'はい',
      close: '閉じる',
      sample: 'サンプル',
      import: 'インポート',
      column: 'カラム',
      apply: '適用',
      selected: '選択済み',
      unselected: '未選択',
      select: '選択',
      deselect: '解除',
      selectAll: 'すべて選択',
      deselectAll: 'すべて解除',
      width: '幅',
      locked: '固定',
      fitColumn: '列幅自動調整',

      selectRowMessage: '行を選択して下さい。',
      deleteConfirmMessage: '削除します。宜しいでしょうか。',
      deletedMessage: '削除しました。',
      updatedMessage: '更新しました。',
      requiredMessage: '必須項目です。',
      selectFileImportMessage: 'インポートファイルを選択してください。',
      importSuccessMessage: 'インポートしました。',

      confirm: '確認',
      error: 'エラー',
      previous: '前へ',
      next: '次へ',

      groupPanelEmpty: '空白',
      noRecords: 'データがありません。',
      pagerFirstPage: '最初のページ',
      pagerLastPage: '最後のページ',
      pagerPreviousPage: '前のページ',
      pagerNextPage: '次のページ',
      pagerPage: 'ページ',
      pagerItemsPerPage: '項目/ページ',
      pagerOf: '/',
      pagerItems: '項目',
      pagerPageNumberInputTitle: 'ページ番号入力',
      filter: '検索',
      filterEqOperator: 'filterEqOperator',
      filterNotEqOperator: 'filterNotEqOperator',
      filterIsNullOperator: 'filterIsNullOperator',
      filterIsNotNullOperator: 'filterIsNotNullOperator',
      filterIsEmptyOperator: 'filterIsEmptyOperator',
      filterIsNotEmptyOperator: 'filterIsNotEmptyOperator',
      filterStartsWithOperator: 'filterStartsWithOperator',
      filterContainsOperator: 'filterContainsOperator',
      filterNotContainsOperator: 'filterNotContainsOperator',
      filterEndsWithOperator: 'filterEndsWithOperator',
      filterGteOperator: 'filterGteOperator',
      filterGtOperator: 'filterGtOperator',
      filterLteOperator: 'filterLteOperator',
      filterLtOperator: 'filterLtOperator',
      filterIsTrue: 'filterIsTrue',
      filterIsFalse: 'filterIsFalse',
      filterBooleanAll: 'filterBooleanAll',
      filterAfterOrEqualOperator: 'filterAfterOrEqualOperator',
      filterAfterOperator: 'filterAfterOperator',
      filterBeforeOperator: 'filterBeforeOperator',
      filterBeforeOrEqualOperator: 'filterBeforeOrEqualOperator',
      filterFilterButton: '検索',
      filterClearButton: 'クリア',
      filterAndLogic: 'filterAndLogic',
      filterOrLogic: 'filterOrLogic',
      loading: 'Loading',
      columnMenu: 'カラムメニュー',
      columnSetting: 'カラム設定',
      columns: 'カラム',
      lock: 'ロック',
      unlock: 'ロック解除',
      sortable: '検索可能',
      sortAscending: '昇順',
      sortDescending: '降順',
      sortedAscending: '昇順',
      sortedDescending: '降順',
      sortedDefault: '既存',
      columnsApply: '適用',
      columnsReset: 'リセット',
      detailExpand: '展開',
      detailCollapse: '縮小',
      filterDateToday: 'filterDateToday',
      filterDateToggle: 'filterDateToggle',
      filterNumericDecrement: 'filterNumericDecrement',
      filterNumericIncrement: 'filterNumericIncrement',

      searchPaneTitle: '検索',
      searchNull: 'ヌル検索',
      reset: 'リセット'
    };

    this.define = {
      locale: Locale.England,
      label: {

      },
      message: {

      },

      lib: this.builtinEn
    };
  }

  private static retrieveLocale(): string {
    let ret = localStorage.getItem('locale');
    if (ret == null) {
      ret = Locale.England;
    }
    return ret;
  }

  public toFile(onCompleted: (code: number, message: string) => void): void {
    const param = new FormData();
    param.append('action', 'file');
    this.api.post<LanguagesInterface>(Config.languagesApi, param, (code, message, data) => {
      if (code === ServiceCode.Success) {
        this.loadLanguages(data);
      }
      if (onCompleted) {
        onCompleted(code, message);
      }
    });
  }

  public toDatabase(onCompleted: (code: number, message: string) => void): void {
    const param = new FormData();
    param.append('action', 'database');
    this.api.post<LanguagesInterface>(Config.languagesApi, param, (code, message, data) => {
      if (code === ServiceCode.Success) {
        this.loadLanguages(data);
      }
      if (onCompleted) {
        onCompleted(code, message);
      }
    });
  }

  public setLocale(locale: string = null): void {
    if (!locale) {
      locale = LanguagesService.retrieveLocale();
    }
    this.changeLocale(locale);
    this.saveLocale(locale);
  }

  public label(text: string): string {
    if (!this.define.label[text]) {
      this.addText(text, 1);
      this.define.label[text] = text;
    }
    return this.define.label[text];
  }
  public message(text: string): string {
    if (!this.define.message[text]) {
      this.addText(text, 2);
      this.define.message[text] = text;
    }
    return this.define.message[text];
  }

  private addText(text: string, type: number): void {
    const form = new FormData();
    form.append('action', 'add');
    form.append('type', type.toString());
    form.append('text', text);
    this.api.post(`${Config.languagesApi}`, form, () => {});
  }

  private saveLocale(locale: string): void {
    localStorage.setItem('locale', locale);
    this.api.get<LanguagesInterface>(`${Config.languagesApi}/${locale}`,
      null, (code, _, data) => {
        if (code === ServiceCode.Success) {
          this.loadLanguages(data);
        }
      });
  }

  private loadLanguages(data): void {
    this.define.locale = data.locale;
    switch (this.define.locale) {
      case Locale.Vietnam:
        this.define.lib = this.builtinVi;
        break;
      case Locale.Japan:
        this.define.lib = this.builtinJa;
        break;
      default:
        this.define.lib = this.builtinEn;
    }
    const modules = ['label', 'message'];
    modules.forEach(module => {
      if (data[module]){
        Object.keys(data[module]).forEach(key => {
          if (data[module][key]) {
            this.define[module][key] = data[module][key];
            // if (this.define.lib[key]){
            //   this.define.lib[key] = data[module][key];
            // }
          }
        });
      }
    });
  }

  private changeLocale(locale: string): void {
    let localeName = 'en-US';
    if (locale === Locale.Vietnam) {
      localeName = 'vi-VN';
    }else if (locale === Locale.Japan) {
      localeName = 'ja-JP';
    }
    this.localeId = localeName;
    (this.intlService as CldrIntlService).localeId = localeName;
  }
}

export interface LibLanguages {
  back: string;
  view: string;
  add: string;
  edit: string;
  cancel: string;
  save: string;
  excel: string;
  copy: string;
  delete: string;
  saveSetting: string;
  resetSetting: string;
  include: string;
  exclude: string;
  contains: string;
  between: string;
  outside: string;
  startWith: string;
  endWith: string;
  no: string;
  yes: string;
  close: string;
  sample: string;
  import: string;
  column: string;
  apply: string;
  selected: string;
  unselected: string;
  select: string;
  deselect: string;
  selectAll: string;
  deselectAll: string;
  width: string;
  locked: string;
  fitColumn: string;

  confirm: string;
  error: string;
  previous: string;
  next: string;

  selectRowMessage: string;
  deleteConfirmMessage: string;
  deletedMessage: string;
  updatedMessage: string;
  requiredMessage: string;
  selectFileImportMessage: string;
  importSuccessMessage: string;


  groupPanelEmpty: string;
  noRecords: string;
  pagerFirstPage: string;
  pagerLastPage: string;
  pagerPreviousPage: string;
  pagerNextPage: string;
  pagerPage: string;
  pagerItemsPerPage: string;
  pagerOf: string;
  pagerItems: string;
  pagerPageNumberInputTitle: string;
  filter: string;
  filterEqOperator: string;
  filterNotEqOperator: string;
  filterIsNullOperator: string;
  filterIsNotNullOperator: string;
  filterIsEmptyOperator: string;
  filterIsNotEmptyOperator: string;
  filterStartsWithOperator: string;
  filterContainsOperator: string;
  filterNotContainsOperator: string;
  filterEndsWithOperator: string;
  filterGteOperator: string;
  filterGtOperator: string;
  filterLteOperator: string;
  filterLtOperator: string;
  filterIsTrue: string;
  filterIsFalse: string;
  filterBooleanAll: string;
  filterAfterOrEqualOperator: string;
  filterAfterOperator: string;
  filterBeforeOperator: string;
  filterBeforeOrEqualOperator: string;
  filterFilterButton: string;
  filterClearButton: string;
  filterAndLogic: string;
  filterOrLogic: string;
  loading: string;
  columnMenu: string;
  columnSetting: string;
  columns: string;
  lock: string;
  unlock: string;
  sortable: string;
  sortAscending: string;
  sortDescending: string;
  sortedAscending: string;
  sortedDescending: string;
  sortedDefault: string;
  columnsApply: string;
  columnsReset: string;
  detailExpand: string;
  detailCollapse: string;
  filterDateToday: string;
  filterDateToggle: string;
  filterNumericDecrement: string;
  filterNumericIncrement: string;


  searchPaneTitle: string;
  searchNull: string;
  reset: string;
}

export interface LanguagesInterface {
  locale: string;
  label: {[key: string]: string}; // {[key: string]: string}; // Partial<LabelLanguages>;
  message: {[key: string]: string}; // {[key: string]: string}; // Partial<MessageLanguages>;
  lib: Partial<LibLanguages>;
}



